var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uk-grid-small uk-text-center",attrs:{"uk-grid":""}},[_c('div',{staticClass:"uk-width-1-1 loading-spinner",attrs:{"uk-spinner":"ratio: 1"}}),_c('div',{staticClass:"uk-width-1-1 loading-message uk-text-bold"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }